import React, {useEffect} from 'react';
import {
	Typography,
	Grid,
	Box
} from "@material-ui/core";
import clsx from "classnames";
import { useStyles } from "../../../hooks";
import styles from "./styles";
import { PUBLICURL } from "../../../main_config";
import BoxRaised from "../../../components/BoxRaised";
import { useMediaQuery, useTheme } from "@material-ui/core";
import {useDispatch} from "react-redux";
import { clearDataScheduler } from '../../../redux/actions/hireActions'

const UnsuccessfulHiring = ({...props}) => {
	const theme = useTheme();
	const matchesUpLG = useMediaQuery(theme.breakpoints.up("lg"));
	const dispatch = useDispatch();
	const classes = useStyles(styles);

	const TypographyProps = {
		component: "h2",
		gutterBottom: true,
		color: "primary",
		align: "center"
	};

	const TypographyTextProps = {
		component: "h4",
		gutterBottom: true,
		color: "gray",
		align: "center"
	};

	useEffect(()=> {
        dispatch(clearDataScheduler())
    },[])

	return (
		<Grid container className={classes.container}>
			<Grid container direction="row"
				justify="center"
				alignItems="center"
				style={{marginTop: 50}}
			>
				<Typography
					{...TypographyProps}
					className={classes.title}

				>
					{props?.location?.state?.message ? props?.location?.state?.message : "Lamentablemente, no podemos brindarte el plan solicitado."}
			</Typography>
			</Grid>

			<Grid container direction="row"
				justify="center"
				alignItems="center"
				className={classes.containerImg}
				style={{marginTop: 50}}
			>

				<img
					src={`${PUBLICURL}/assets/images/hire/HireUnsuccess.png`}
					alt="Exito"
				//className={classes.img1}
				/>
			</Grid>
		</Grid>
	);
}

export default UnsuccessfulHiring;